"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SplitListItem = function SplitListItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["children", "className"]);

  if (_react["default"].Children.count(children) > 2) {
    console.warn("SplitListItem exceeded max children: Can only contain 2 children. Others will be omitted.");
  }

  return _react["default"].createElement(ListItem, _extends({
    className: className
  }, restProps), _react["default"].Children.map(children, function (child, index) {
    return index <= 1 ? _react["default"].createElement("span", null, child) : null;
  }));
};

SplitListItem.themeProps = {
  listItem: {
    name: "split_list",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "SplitListItem__ListItem",
  componentId: "sc-15ys2zm-0"
})(["position:relative;display:flex;justify-content:space-between;align-items:center;list-style:none;border-bottom:1px solid ", ";padding:", " ", ";font-size:", ";font-family:", ";&:last-child{border-bottom:none;}", ";"], _theming.color.line, _theming.spacing.tiny, _theming.spacing.medium, _theming.font.base, _theming.fontFamily.body(), (0, _theming.applyVariants)(SplitListItem.themeProps.listItem));

SplitListItem.defaultProps = {
  className: ""
};
SplitListItem.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string
};
var _default = SplitListItem;
exports["default"] = _default;